enum RewardPackageType {
    ReloadableUSA = 'ReloadableUSA',
    ReloadableCAN = 'ReloadableCAN',
    SingleLoadUSA = 'SingleLoadUSA',
    SingleLoadCAN = 'SingleLoadCAN',
    VirtualUSA = 'VirtualUSA',
    CheckUSA = 'CheckUSA',
    CheckCAN = 'CheckCAN',
    Points = 'Points',
    // Both Galileo Cards have been removed, and will no longer be selectable.
    SingleLoadUSAGalileo = 'SingleLoadUSAGalileo',
    ReloadableUSAGalileo = 'ReloadableUSAGalileo',
    RetailCard = 'RetailCard',
    ReloadableCANVisa = 'ReloadableCANVisa',
}

export default RewardPackageType;
